
































import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import FormErrors from "@/lib/components/FormErrors.vue";
import FormField from "@/lib/components/FormField.vue";
import SubmitButton from "@/lib/components/SubmitButton.vue";

import GeneralFormMixin from "@/lib/mixins/GeneralForm";
import dataStore from "@/store";

import BatchInvoice from "../batch-invoice.model";
import FactoryInvoiceStore from "../store";

@Component({
  components: {
    FormErrors,
    FormField,
    SubmitButton,
  },
})
export default class BatchInvoiceShippingForm extends mixins(GeneralFormMixin) {
  @Prop({ required: true })
  public readonly invoiceId!: string;

  public shippingAmount: number | string = "";

  private fFactoryInvoiceStore: FactoryInvoiceStore;

  get batchInvoice(): BatchInvoice | undefined {
    return this.fFactoryInvoiceStore.getBatchInvoiceByInvoiceId(this.invoiceId);
  }

  constructor() {
    super();
    this.fFactoryInvoiceStore = getModule(FactoryInvoiceStore, dataStore);
  }

  protected async performSubmit(): Promise<void> {
    await this.fFactoryInvoiceStore.saveShippingAmount({
      invoiceId: this.invoiceId,
      shippingAmount: Number(this.shippingAmount),
    });

    this.$emit("shipping-saved");
  }

  @Watch("batchInvoice", { immediate: true })
  private onBatchInvoiceChange(batchInvoice?: BatchInvoice): void {
    this.shippingAmount =
      batchInvoice?.shippingAmount == null ? "" : batchInvoice.shippingAmount;
  }
}
